// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import React from "react";
import { Select, Form } from "antd";

// -------------------------------------------------------------------------------
// Components
// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
// Styles
// -------------------------------------------------------------------------------
import StyledFormTagSelect from "./styles";

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------

const FormTagSelect = ({ name, label, placeholder, rules, options, className, prefix, postfix, ...rest }) => {
	return (
		<StyledFormTagSelect className={`${className} sb-form-tag-select`}>
			<Form.Item name={name} label={<span>{label}</span>} rules={rules}>
				<Select
					options={options}
					mode="tags"
					allowClear
					filterOption={(input, option) => option.label?.toLowerCase()?.includes(input.toLowerCase())}
					placeholder={placeholder}
					{...rest}
					data-id={name}
				/>
			</Form.Item>
		</StyledFormTagSelect>
	);
};

export default FormTagSelect;

